<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>{{ modalTitle }}</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <form>
    <div class="form-group" [formGroup]="form">
      <div class="row" *ngIf="!isOemProcedureMode">
        <div class="col-12">
          <label>Worker Level</label>
          <div class="worker-level-display">{{ workerLevelLabel }}</div>
        </div>
      </div>

      <div class="row mt-4 mb-4">
        <div class="col-12">
          <label>Competencies <span class="required-text">(required)</span></label>
          <div *ngIf="!competencyOptions.length" class="small-spinner">
            <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
          </div>

          <p-dropdown
            class="form-control"
            formControlName="competency"
            [options]="competencyOptions"
            placeholder="Select competency..."
            [style]="{ width: '100%' }"
            filter="true">
          </p-dropdown>
        </div>
      </div>

      <div
        class="field-highlight mt-5 mb-5"
        *ngIf="showTurbineFields">
        <div class="row">
          <div class="col-md-4">
            <div class="filter-flex-row">
              <label>OEM</label>
              <span *ngIf="isManufacturerLoading" class="small-spinner-inline">
                <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
              </span>
            </div>
            <p-dropdown
              class="form-control"
              formControlName="oem"
              [options]="oemOptions"
              optionLabel="label"
              placeholder="Optional"
              [style]="{ width: '100%' }">
            </p-dropdown>
          </div>
          <div class="col-md-4">
            <div class="filter-flex-row">
              <label>Model</label>
              <span *ngIf="isModelAndRatingLoading" class="small-spinner-inline">
                <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
              </span>
            </div>
            <p-multiSelect
              *ngIf="isProcedureMode; else singleModelSelect"
              class="form-control"
              formControlName="model"
              [options]="modelOptions"
              optionLabel="label"
              defaultLabel="Optional"
              [panelStyle]="{ minWidth: '18rem' }"
              [style]="{ width: '100%' }">
            </p-multiSelect>
            <ng-template #singleModelSelect>
            <p-dropdown
              class="form-control"
              formControlName="model"
              [options]="modelOptions"
              optionLabel="label"
              placeholder="Optional"
              [style]="{ width: '100%' }">
            </p-dropdown>
            </ng-template>
          </div>
          <div class="col-md-4">
            <div class="filter-flex-row">
              <label>Rating</label>
              <span *ngIf="isModelAndRatingLoading" class="small-spinner-inline">
                <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
              </span>
            </div>
            <p-multiSelect
              *ngIf="isProcedureMode; else singleRatingSelect"
              class="form-control"
              formControlName="rating"
              [options]="ratingOptions"
              optionLabel="label"
              defaultLabel="Optional"
              [panelStyle]="{ minWidth: '18rem' }"
              [style]="{ width: '100%' }">
            </p-multiSelect>
            <ng-template #singleRatingSelect>
            <p-dropdown
              class="form-control"
              formControlName="rating"
              [options]="ratingOptions"
              optionLabel="label"
              placeholder="Optional"
              [style]="{ width: '100%' }">
            </p-dropdown>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-round btn-default">Cancel</button>
    <button type="button" (click)="onSubmit()" [disabled]="!form.valid || !form.dirty || isSubmitting" class="btn btn-sm btn-round btn-success">Save</button>
  </p-footer>
</div>
